const A = 40487.57;
const B = 0.00007096758;
const C = 91610.74;
const D = -40467.74;

// 根据camera高度近似计算当前层级
export const heightToZoom = (height) => {
    return Math.round(D + (A - D) / (1 + Math.pow(height / C, B)));
}

// 根据当前层级近似计算camera高度
export const zoomToHeight = (zoom) => {
    return Math.round(C * Math.pow((A - D) / (zoom - D) - 1, 1 / B));
}
